export default {
      id: "rutube-usage",
      viewBox: "0 0 192 192",
      url: __webpack_public_path__ + "sprite.svg#rutube-usage",
      toString: function () {
        return this.url;
      }
    }